import { render, staticRenderFns } from "./ProductoCard.vue?vue&type=template&id=14ea0600&scoped=true"
import script from "./ProductoCard.vue?vue&type=script&lang=js"
export * from "./ProductoCard.vue?vue&type=script&lang=js"
import style0 from "./ProductoCard.vue?vue&type=style&index=0&id=14ea0600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea0600",
  null
  
)

export default component.exports